import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import { BaseTextBox } from '../controls/BaseTextBox';
import { BaseCombobox } from '../controls/BaseCombobox';
import { BackButton } from '../controls/BackButton';
import { BasePasswordBox } from '../controls/BasePasswordBox';
import Toast from '../controls/BaseToast';
import validator from 'validator';
import Select from 'react-select';

export class AccountForm extends Component {
    static displayName = AccountForm.name;

    constructor(props) {
        super(props);
        this.state = { name: '', selectedRoleId: '', accountGroup: '0', password: '', confirmPassword: '', cellPhone: '', email: '', fullName: '', roles: [], loadingRoles: true, errMessage: '', passwordErrMessage: '', confirmPasswordErrMessage: '', deliverAccountCodes: [], deliverAccountCodeSelected:[] };
        this.handleBaseTextBoxChange = this.handleBaseTextBoxChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAccountGroupChange = this.handleAccountGroupChange.bind(this);
        this.handleRoleSelectChange = this.handleRoleSelectChange.bind(this);
        this.handleOnSearch = this.handleOnSearch.bind(this);
    }

    async loadRoles() {
        const token = await authService.getAccessToken();
        const response = await fetch('role/GetRoles', {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        var selectRoleId = '';
        if (data.length > 1) {
            selectRoleId = data[0].id;
        }
        this.setState({ roles: data, selectedRoleId: selectRoleId, loadingRoles: false });

        var id = this.props.id;
        if (id) {
            this.locaData(id);
        }
    }

    componentDidMount() {
        this.loadRoles();
    }

    async locaData(id) {
        const token = await authService.getAccessToken();
        fetch('account/getaccount/' + id, { headers: !token ? {} : { 'Authorization': `${token}` } })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    name: data.name, selectedRoleId: data.role.id, accountGroup: data.accountGroup, cellPhone: data.cellPhone, email: data.email, fullName: data.fullName, deliverAccountCodeSelected: [{ 'label': data.deliverAccountCode, 'value': data.deliverAccountCode }]
                });
            });
    }


    handleAccountGroupChange(event) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;

        this.setState({
            accountGroup: value
        });
    }
    handleRoleSelectChange(event) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;

        this.setState({
            selectedRoleId: value
        });
    }
    handleBaseTextBoxChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }
    onSelectChange = selectedOption => {
        this.setState({
            deliverAccountCodeSelected: selectedOption
        })
    };
    handleOnSearch(keyword, e) {
        if (keyword.trim().length > 0) {
            authService.getAccessToken().then(token => {
                fetch('dealer/GetDeliverAccountCodesWithDealerId?keyword=' + keyword, { headers: !token ? {} : { 'Authorization': `${token}` } })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                         this.setState({ deliverAccountCodes: data.entities.map((item) => { return { value: item.code, label: item.code } }) });
                    })
            });
        }
    }
    async handleSubmit(e) {
        e.preventDefault();
        const name = this.state.name&&this.state.name.trim();
        const password = this.state.password&&this.state.password.trim();
        const confirmPassword = this.state.confirmPassword&&this.state.confirmPassword.trim();
        const roleId = this.state.selectedRoleId;
        const accountGroup = this.state.accountGroup;
        const cellphone = this.state.cellPhone&&this.state.cellPhone.trim();
        const email = this.state.email &&this.state.email.trim();
        const fullName = this.state.fullName && this.state.fullName.trim();
        const deliverAccountCode = this.state.deliverAccountCodeSelected && this.state.deliverAccountCodeSelected.value;
       // console.log(this.state.deliverAccountCodeSelected);
        //  send request to the server
        const token = await authService.getAccessToken();
        const isNew = this.props.isNew;
        let response = null;
        if (name.length == 0) {
            this.setState({ errMessage: 'Required' });
            return;
        }

        if (isNew) {
            if (password.length == 0) {
                this.setState({ passwordErrMessage: 'Required' });
                return;
            }
            if (!validator.isStrongPassword(password, {
                minLength: 6, minLowercase: 1,
                minUppercase: 1, minNumbers: 1, minSymbols: 1
            })) {
                Toast.warn('PasswordRuleRequired');
                return;
            }
            if (password !== confirmPassword) {
                this.setState({ confirmPassword: '' });
                this.setState({ confirmPasswordErrMessage: 'ConfirmPasswordError' });
                return;
            }

            response = await fetch('account/Create', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'name': name,
                    'password': password,
                    'roleId': roleId,
                    'accountGroup': parseInt(accountGroup),
                    'cellPhone': cellphone,
                    'email': email,
                    'fullName': fullName,
                    'deliverAccountCode': deliverAccountCode
                })
            });


        }
        else {
            response = await fetch('account/Edit', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({
                    'name': name,
                    'id': this.props.id,
                    'roleId': roleId,
                    'accountGroup': parseInt(accountGroup),
                    'cellPhone': cellphone,
                    'email': email,
                    'fullName': fullName,
                    'deliverAccountCode': deliverAccountCode
                })
            });
        }

        if (response.status == 200) {
            let data = await response.json();
            if (data) {
                if (data.status == 0) {
                    window.history.back(-1);
                }
                else {
                    Toast.warn(data.message);
                    // this.setState({ errMessage: data.message });
                }
            }
        }
        else {
            console.error('response.status:' + response.status)
        }
    }

    rendPasswordSection() {
        return (<div className="col-span-6 sm:col-span-3">
            <label className="block text-sm font-medium text-gray-700" htmlFor="examplePassword"><FormattedMessage id="password" /></label>
            <BasePasswordBox classnames="mt-1" name="password" autocomplete="new-password" value={this.state.password} onChange={this.handleBaseTextBoxChange} errmessage={this.state.passwordErrMessage} />
        </div>
        );
    }
    rendConfirmPasswordSection() {
        return (<div className="col-span-6 sm:col-span-3">
            <label className="block text-sm font-medium text-gray-700" htmlFor="confirmPassword"><FormattedMessage id="confirmpassword" /></label>
            <BasePasswordBox classnames="mt-1" name="confirmPassword" value={this.state.confirmPassword} onChange={this.handleBaseTextBoxChange} errmessage={this.state.confirmPasswordErrMessage} />
            {/* {this.state.showConfirmPasswordError ? <div className="text-red-600  text-xs"><FormattedMessage id="ConfirmPasswordError" /></div> : ''}*/}
        </div>);
    }

    render() {
        const customStyles = {
            control: (base, state) => ({
                ...base,
                "*": {
                    boxShadow: "none !important"
                },
            }),
            menuPortal: base => ({ ...base, zIndex: 9999 }),
            menuList: (base) => ({
                ...base,
                maxHeight: "200px"
            })
        }
        let passwordSection = '';
        let confirmPasswordSection = '';
        const isNew = this.props.isNew;
        if (isNew) {
            passwordSection = this.rendPasswordSection();
            confirmPasswordSection = this.rendConfirmPasswordSection();
        }
        return (
            <div className="border-t border-gray-200">
                <dl>
                    <form onSubmit={this.handleSubmit}>
                        <div className="shadow overflow-hidden sm:rounded-md">
                            <div className="px-4 py-5 bg-white sm:p-6">
                                <div className="grid grid-cols-6 gap-6">
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="name" className="block text-sm font-medium text-gray-700"><FormattedMessage id="Accounts" /></label>
                                        <BaseTextBox classnames="mt-1" type="text" name="name" id="name" placeholder="" value={this.state.name} onChange={this.handleBaseTextBoxChange} errmessage={this.state.errMessage} />
                                    </div>
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="roleSelect" className="block text-sm font-medium text-gray-700"><FormattedMessage id="Role" /></label>
                                        <BaseCombobox classnames="mt-1" name="roleSelect" id="roleSelect" onChangeCapture={this.handleRoleSelectChange} value={this.state.selectedRoleId}>
                                            {this.state.roles.map((item, index) => (<option key={index} value={item.id}>{item.name}</option>)
                                            )}

                                        </BaseCombobox>

                                    </div>
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="accountGroup" className="block text-sm font-medium text-gray-700"><FormattedMessage id="AccountGroup" /></label>
                                        <BaseCombobox classnames="mt-1" name="accountGroup" id="accountGroup" onChangeCapture={this.handleAccountGroupChange} value={this.state.accountGroup}>
                                            <FormattedMessage id="Factory">
                                                {text => <option value="0">{text}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="Dealer">
                                                {text => <option value="1">{text}</option>}
                                            </FormattedMessage>
                                            <FormattedMessage id="DealerAdmin">
                                                {text => <option value="2">{text}</option>}
                                            </FormattedMessage>
                                        </BaseCombobox>
                                    </div>
                                    {passwordSection}
                                    {confirmPasswordSection}
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="fullName" className="block text-sm font-medium text-gray-700"><FormattedMessage id="AccountFullName" /></label>
                                        <BaseTextBox classnames="mt-1" type="text" name="fullName" id="fullName" value={this.state.fullName} onChange={this.handleBaseTextBoxChange} />
                                    </div>
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="cellPhone" className="block text-sm font-medium text-gray-700"><FormattedMessage id="cellphone" /></label>
                                        <BaseTextBox classnames="mt-1" type="text" name="cellPhone" id="cellPhone" placeholder="" value={this.state.cellPhone} onChange={this.handleBaseTextBoxChange} />
                                    </div>
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700"><FormattedMessage id="Email" /></label>
                                        <BaseTextBox classnames="mt-1" type="email" name="email" id="email" placeholder="" value={this.state.email} onChange={this.handleBaseTextBoxChange} />
                                    </div>
                                    <div className="col-span-6 sm:col-span-3">
                                        <label htmlFor="deliverAccountCode" className="block text-sm font-medium text-gray-700"><FormattedMessage id="DeliverAccountCode" /></label>
                                        <Select menuPortalTarget={document.body} className="mt-1 min-w-0 w-full inline-block"
                                            onChange={this.onSelectChange}
                                            closeMenuOnSelect={true}
                                            isClearable={true }
                                            styles={customStyles}
                                            placeholder=""
                                            value={this.state.deliverAccountCodeSelected}
                                            options={this.state.deliverAccountCodes}
                                            onInputChange={this.handleOnSearch}
                                        />

                                    </div>
                                </div>
                            </div>
                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                                <button
                                    className="inline-flex justify-center py-2 px-4 mr-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                ><FormattedMessage id="Submit" /></button>
                                <BackButton />
                            </div>
                        </div>
                    </form>
                </dl>
            </div>
        );
    }
}
